import { type Enum } from '@webapp/infrastructure/types/Enum'

export const GuidedIntakePageTypes = {
  CLASSIC: 'classic',
  NEXT_GEN: 'next_gen',
} as const

export type GuidedIntakePageTypeEnum = Enum<typeof GuidedIntakePageTypes>
